const HrLine = () => <hr className="sm:hidden" />;

export default HrLine;
